import { Injector } from '@angular/core';
import { DragDropHandleBuilder } from 'core-app/features/work-packages/components/wp-fast-table/builders/drag-and-drop/drag-drop-handle-builder';
import { WorkPackageTable } from 'core-app/features/work-packages/components/wp-fast-table/wp-fast-table';
import { WorkPackageViewOrderService } from 'core-app/features/work-packages/routing/wp-view-base/view-services/wp-view-order.service';
import { WorkPackageViewColumnsService } from 'core-app/features/work-packages/routing/wp-view-base/view-services/wp-view-columns.service';
import { InjectField } from 'core-app/shared/helpers/angular/inject-field.decorator';
import { QueryOrder } from 'core-app/core/apiv3/endpoints/queries/apiv3-query-order';
import { PrimaryRenderPass, RowRenderInfo } from '../primary-render-pass';

export class DragDropHandleRenderPass {
  @InjectField() public wpTableColumns:WorkPackageViewColumnsService;

  @InjectField() public wpTableOrder:WorkPackageViewOrderService;

  // Drag & Drop handle builder
  protected dragDropHandleBuilder = new DragDropHandleBuilder(this.injector);

  constructor(public readonly injector:Injector,
    private table:WorkPackageTable,
    private tablePass:PrimaryRenderPass) {
  }



public findVisibleToFieldKey(obj:any, keyword = 'Visible To'):string|undefined {
  const seen = new Set<any>();
  const lowerKeyword = keyword.toLowerCase();

  const search = (o:any, path = ''):string|undefined => {
    if (seen.has(o)) return;
    seen.add(o);

    for (const key in o) {

      if (!Object.prototype.hasOwnProperty.call(o, key)) continue;
      const value = o[key];
      const currentPath = path ? `${path}.${key}` : key;

      if (typeof value === 'string' && value.toLowerCase() === lowerKeyword && currentPath.includes('customField')) {
        return currentPath.split('.').find(part => part.startsWith('customField'));
      } else if (typeof value === 'object' && value !== null) {
        const result = search(value, currentPath);
        if (result) return result;
      }
    }

    return undefined;
  };

  return search(obj);
}

public visibleToParentIds:Set<string> = new Set(); // e.g. populated from primary WP IDs with 'Visible To' value

      // Helper: recursively check parents for the field value
      public hasInheritedLock(wp: any): boolean {
        if (!wp?.parent) return false;
        const parent = wp.parent;
        if (this.visibleToParentIds.has(String(wp.parent?.id))) return true;
        return this.hasInheritedLock(parent);
      }

  public render() {
    if (!this.table.configuration.dragAndDropEnabled) {
      return;
    }

if (!window.VISIBLE_TO_CF_KEY) {
  const root = this.injector; // or any root object you're scanning
  window.VISIBLE_TO_CF_KEY = this.findVisibleToFieldKey(root) || '';
}



    this.wpTableOrder.withLoadedPositions().then((positions:QueryOrder) => {
      this.tablePass.renderedOrder.forEach((row:RowRenderInfo, position:number) => {
        // We only care for rows that are natural work packages and are not relation sub-rows

  const key = window.VISIBLE_TO_CF_KEY;

  if (key && row && row.workPackage) {
    const currentUserId = window.CURRENT_USER_ID;
    const wpAuthorId = row.workPackage.author?.id;
    const value = row.workPackage[key];

    const td = row.element.querySelector('.wp-table--cell-td.id') as HTMLElement;
    const innerSpan = td?.querySelector('.wp-table--cell-container');

    if (value?.length > 0) {
      if (wpAuthorId === String(currentUserId)) {
        innerSpan?.classList.add('rk-locked-icon-owner'); // 👤
      } else {
        innerSpan?.classList.add('rk-locked-icon'); // 🔒
      }
      this.visibleToParentIds.add(String(row?.workPackage?.id));
    } else if (this.hasInheritedLock(row.workPackage)) {
      innerSpan?.classList.add('rk-locked-icon-inherited'); // 🪄
    }
  }

        if (!row.workPackage || row.renderType === 'relations') {
          return;
        }

        const handle = this.dragDropHandleBuilder.build(row.workPackage, positions[row.workPackage.id!]);

        if (handle) {
          row.element.replaceChild(handle, row.element.firstElementChild!);
        }
      });
    });
  }
}
